import { inject, Injectable } from '@angular/core';
import { ProfileType } from '../../interfaces/profile-type';
import { OUTLAW_COMMUNITY_ROUTES } from '../../providers/community-route.provider';

export type ProfileLinkContext = 'feed' | 'post';

@Injectable({ providedIn: 'root' })
export class ProfileLinkService {
  #routes = inject(OUTLAW_COMMUNITY_ROUTES);

  buildProfileLink(profileType: ProfileType, username?: string, context: ProfileLinkContext = 'feed'): string {
    if (!username) return '';

    if (profileType === 'user' && context === 'feed') return '';

    switch (profileType) {
      case 'user':
        return this.#normalizePath(this.#routes.home);
      case 'group':
        return this.#normalizePath(`${this.#routes.profile}/${username}`);
    }
  }

  #normalizePath(path: string): string {
    return `/${path}`.replace(/\/+/g, '/');
  }
}
